/* eslint-disable class-methods-use-this */
import * as Yup from 'yup';
import { getRequiredText } from '../../../../../../global/helpers/transformer';
import { Institution } from '../../../../../../global/models/institution-model';
import { Person } from '../../../../../../global/models/person-model';
import { DocuSignRequest } from '../../../docusign/models/docusign-models';
import { PlanSummary } from '../../institution-model';
import { DBPlanAdoptionContentModel, DbPlanFormModel } from '../models/plan-adoption-form-models';
import { PlanAdoptionWizard } from './plan-adoption-wizard';

export class DbPlanAdoptionWizard extends PlanAdoptionWizard {

	onSubmit: any;

	createSubmitModel(formValue: DbPlanFormModel, envelopeId?: string) {
		return {
			db_plan: {
				plan_effective_date: formValue?.adoption_date,
				plan_population: 'lay',
				latest_amendment_attributes: {
					billing_schedule: 'monthly',
				},
				docusign_envelope_id: envelopeId,
			},
		};
	}

	getFormContentModel(): DBPlanAdoptionContentModel {
		return null;
	}


	getFormValidationSchema() {
		return Yup.object().shape({
			adoption_date: Yup.date().nullable().required(getRequiredText(this.epiContent?.labelSettingState?.epiContent?.requiredFormat, this.epiContent?.institutionSettingsState?.epiContent?.planAdoptionDateLabel)),
		});
	}

	getFormInitialValue(): DbPlanFormModel {
		return {
			adoption_date: null,
		};
	}

	needIndemnify(planSummary: PlanSummary) {
		return !!planSummary?.dc?.active[0]?.effective_date || !!planSummary?.rsvp?.active[0]?.effective_date;
	}

	hasRsvp(planSummary: PlanSummary) {
		return !!planSummary?.rsvp?.active[0]?.effective_date;

	}

	getIndemnifyWarningTitle(planSummary: PlanSummary) {
		if (planSummary?.rsvp?.active[0]?.effective_date) return this?.epiContent?.institutionSettingsState?.epiContent?.layDbIndemnifyWarningTitleRsvp;
		if (planSummary?.dc?.active[0]?.effective_date) return this?.epiContent?.institutionSettingsState?.epiContent?.layDbIndemnifyWarningTitleDc;
		return null;
	}


	prepareDocuSignRequest(person: Person, currentInstitution: Institution, token: string, loginTime: string, needsIndemnify: boolean) {
		const content = this.epiContent?.institutionSettingsState?.epiContent;
		const docuSignRequest: DocuSignRequest = {
			authToken: token,
			loginTime,
			subject: content?.layDbDocuSignSubject,
			templateId: needsIndemnify ? content?.layDbDocuSignIndemnifactionTemplateId : content?.layDbDocuSignTemplateId,
			signerEmail: person?.personal_email_address,
			signerName: `${person?.first_name}${person?.middle_name ? ' ' : ` ${person?.middle_name} `}${person?.last_name}`,
			signerClientId: person?.personal_email_address || person?.person_guid,
			signerRoleName: content?.docuSignSignerRoleName || 'Employer',
			customFieldTemplateId: content?.layDbDocuSignTemplateId,
			customFieldClientId: currentInstitution?.org_client_nbr,
		};

		return docuSignRequest;
	}

	prepareIndemnifyDocuSignRequest(person: Person, currentInstitution: Institution, token: string, loginTime: string) {
		const content = this.epiContent?.institutionSettingsState?.epiContent;
		const docuSignRequest: DocuSignRequest = {
			authToken: token,
			loginTime,
			subject: content?.indemnifyLayDbDocuSignSubject,
			templateId: content?.indemnifyLayDbDocuSignTemplateId,
			signerEmail: person?.personal_email_address,
			signerName: `${person?.first_name}${person?.middle_name ? ' ' : ` ${person?.middle_name} `}${person?.last_name}`,
			signerClientId: person?.personal_email_address || person?.person_guid,
			signerRoleName: content?.docuSignSignerRoleName || 'Employer',
			customFieldTemplateId: content?.indemnifyLayDbDocuSignTemplateId,
			customFieldClientId: currentInstitution?.org_client_nbr,
		};

		return docuSignRequest;
	}

}